import type { VariablesOf } from '@graphql-typed-document-node/core';
import { graphql } from '@/gql';

export const CreateSubgroupMutation = graphql(`
    mutation CreateSubgroup($input: CreateSubgroupInput!) {
        createSubgroup(input: $input) {
            __typename
            ... on CreateSubgroupSuccessfulResponse {
                result {
                    ...SubgroupListItemData
                }
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);

export type CreateSubgroupMutationVariables = VariablesOf<typeof CreateSubgroupMutation>;
